import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiResponse } from "types/api";
import {
  MemberAwardReqPayLoad,
  MemberAwardVipType,
  MemberPayload,
  MemberVipResponseType,
} from "types/memberVip";

export const memberApi = {
  async getMemberVip(username: string, payload: MemberPayload) {
    const response = await axiosRequest.post<MemberVipResponseType>(
      "/",
      payloadHelper("MemberVIP", username, payload),
    );
    return response.data;
  },

  async getMemberAward(username: string, payload: MemberPayload) {
    const response = await axiosRequest.post<MemberAwardVipType>(
      "/",
      payloadHelper("MemberAward", username, payload),
    );
    return response.data;
  },

  async getMemberAwardReq(typename: string, payload: MemberAwardReqPayLoad) {
    const { data } = await axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("MemberAwardReq", typename, payload),
    );
    return data;
  },
};
